/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicationHealthListRequest {
    getFixupPrototypeFunction() { return ApplicationHealthListRequest.fixupPrototype; }

    static newInstance(model: Partial<ApplicationHealthListRequest>): ApplicationHealthListRequest {
        let obj = Object.assign(new ApplicationHealthListRequest(), model);
        ApplicationHealthListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicationHealthListRequest>): ApplicationHealthListRequest {
        if (!model) return null;
        return ApplicationHealthListRequest.newInstance(<ApplicationHealthListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicationHealthListRequest) {
        if (!obj) return;

        models.ApplicationHealthListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicationHealthListRequest): boolean {
        Object.setPrototypeOf(obj, ApplicationHealthListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ApplicationHealthRequestFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ApplicationHealthSummarySortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ApplicationHealthSummarySortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ApplicationHealthRequestFilter;

}
